import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'roundOff' })
export class RoundOffPipe implements PipeTransform {
    transform(value, type) {
        if (value && !isNaN(value)) {
            let data = +value;
            value = (type == 'int') ? Math.round(data) : data.toFixed(2);
        }
        return value;
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/common/pipe/roundOff.pipe.ts